import React from 'react';

import { TileWithLoading } from '@react/Pages/AccountSettingsPage/YourDataSection/TileWithLoading';
import { SecurityConfigurationTileItem } from './SecurityConfigurationTileItem';

import './SecurityConfigurationTileItem.scss';

interface SecurityConfigurationTileBaseProps {
  ssoHref: string;
  twoFactorHref: string;
  twoFactorEnabled: boolean;
}

const SecurityConfigurationTileBase: React.FC<SecurityConfigurationTileBaseProps> = ({
  twoFactorHref,
  twoFactorEnabled,
  ssoHref,
}) => {
  // TODO use useRouter() stateService.href when account-data.controller.js is migrated
  const fields = [
    {
      title: t('label.single-sign-on'),
      value: t('label.sso.status'),
      icon: 'security-sso',
      href: ssoHref,
    },
    {
      title: t('security-package.2fa.switcher.label'),
      value: twoFactorEnabled ? t('security-package.2fa.tile.enabled') : t('security-package.2fa.tile.disabled'),
      icon: 'security-two-factor',
      href: twoFactorHref,
    },
  ];

  return (
    <>
      <div className="your-data-card__title">{t('label.secuity-configuration')}</div>
      <div className="your-data-card__body">
        {fields.map(field => (
          <SecurityConfigurationTileItem key={field.title} {...field} />
        ))}
      </div>
    </>
  );
};

export default TileWithLoading(SecurityConfigurationTileBase);
